// ==================== ENUMS ====================

export enum ClaimMatchType {
  domain_match = 'domain_match',
  manual_review = 'manual_review',
}

export enum ClaimRequestStatus {
  pending_verification = 'pending_verification',
  pending_review = 'pending_review',
  approved = 'approved',
  rejected = 'rejected',
}

// ==================== REQUEST TYPES (client-safe) ====================

export interface InitiateClaimData {
  email: string;
}

export interface VerifyClaimPinData {
  code: string;
}

export interface SubmitAdditionalInfoData {
  fullName: string;
  jobTitle: string;
  companyName: string;
  relationship: string;
  linkedinUrl?: string;
}

export interface AdminReviewClaimData {
  note?: string;
}

// ==================== RESPONSE TYPES ====================

export interface InitiateClaimResponseDto {
  claimRequestId: string;
  matchType: ClaimMatchType;
}

export interface VerifyClaimPinResponseDto {
  approved: boolean;
  requiresAdditionalInfo: boolean;
}

export interface ClaimRequestResponseDto {
  id: string;
  providerId: string;
  email: string;
  emailVerified: boolean;
  matchType: ClaimMatchType;
  status: ClaimRequestStatus;
  fullName: string | null;
  jobTitle: string | null;
  companyName: string | null;
  relationship: string | null;
  linkedinUrl: string | null;
  reviewedBy: string | null;
  reviewedAt: string | null;
  reviewNote: string | null;
  /** Client IP at claim initiation (if available). Mirrors form submissions. */
  ipAddress: string | null;
  userAgent: string | null;
  createdAt: string;
  updatedAt: string;
}

export interface PendingClaimReviewsResponseDto {
  data: ClaimRequestResponseDto[];
  total: number;
  page: number;
  limit: number;
}
